/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface NetSuiteConfig
 */
export interface NetSuiteConfig {
  /**
   *
   * @type {string}
   * @memberof NetSuiteConfig
   */
  accountId: string;
}

/**
 * Check if a given object implements the NetSuiteConfig interface.
 */
export function instanceOfNetSuiteConfig(
  value: object,
): value is NetSuiteConfig {
  if (!("accountId" in value) || value["accountId"] === undefined) return false;
  return true;
}

export function NetSuiteConfigFromJSON(json: any): NetSuiteConfig {
  return NetSuiteConfigFromJSONTyped(json, false);
}

export function NetSuiteConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NetSuiteConfig {
  if (json == null) {
    return json;
  }
  return {
    accountId: json["accountId"],
  };
}

export function NetSuiteConfigToJSON(json: any): NetSuiteConfig {
  return NetSuiteConfigToJSONTyped(json, false);
}

export function NetSuiteConfigToJSONTyped(
  value?: NetSuiteConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    accountId: value["accountId"],
  };
}
